import React,{useState} from 'react'
import styled from 'styled-components';
// import EthImgLogo from './eth.svg'
// import Image from 'next/image';

import {
  ActivityContainer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ActivityHeader,
  HeadingWrapper,
  HeaderTitle,
  Button,
  AccordianHeading,
  HeadingMain,
  SubHeadingWrap,
  HeadingSub,
  AccordionBody,
  Typography,
  AccordianWrapper,
  AccordianMain,
  AccordianSubWrap,
  AccordianSub,
  AccordianRoyaltyWrap,
  NFTinfo,
  EthWrap,
  QuestionWrapper,
} from './activityElements'


import {IoMdCart} from 'react-icons/io';
import { FaRegQuestionCircle} from 'react-icons/fa';
// import { HelpBox } from '../HelpBox';

// converts wei to eth
const wei_to_eth = (wei) => {
    return  Math.round((wei * Math.pow(10,-18)) * process.env.REACT_APP_PLACEVALUE) /  process.env.REACT_APP_PLACEVALUE
}


export const ActivityBox = (data) => {


  const {helpText,state}  = data;
  const [expanded, setExpanded] = useState('');

  const nfts = state.currentInfo.nfts;
  const isLoading = state.isLoading

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded  ? panel : false);
  };



  const toggleAll = () => {
     
      if (expanded === 'all'){
        setExpanded('')
        // console.log(expanded)
      }else{
        setExpanded('all')
        // console.log(expanded)
      }
  }

  const [hoverIndex, changeHoverIndex] = useState('');
  const showBubble = {visibility: '1', opacity: '1',transition: 'all 0s ease-in-out',};
  const hideBubble = {opacity: '0',visibility: '0', transition: 'all 0s ease-in-out',};

  


  return (
    <ActivityContainer>
      <FaderContainer>
      
        {/* activity box title */}
        <ActivityHeader>
          <HeaderTitle>Holder Rewards Activity</HeaderTitle>
          {/* {nfts.length > 0 && <Button onClick={toggleAll}>{expanded === 'all' ? 'Close all' : 'See All'}</Button>} */}
        </ActivityHeader>

        {/* accordian heading */}
        <AccordianHeading>
            <HeadingWrapper>

                <HeadingMain>Nft Name</HeadingMain>

                <SubHeadingWrap>
                    <HeadingSub style={{flex:'1.5'}}>Price</HeadingSub>
                    <HeadingSub style={{flex:'2'}}>Date</HeadingSub>
                    <HeadingSub style={{flex:'2'}}>Royalty Recieved</HeadingSub>
                </SubHeadingWrap>
            </HeadingWrapper>
        </AccordianHeading>


        
        {/* accordian section */}
       {isLoading ? 
          <EmptyConainer>
           {/* <EmptyText>Loading Data...</EmptyText> */}
            <Spinner/>
              <Gradient/>
          </EmptyConainer> 
       :

        <AccordionBody>
          <div style={{ height:'100%'}}>

          {/* creates accordian for each nft */}
          {nfts.map((nft, index)=> {

              return(
              <Accordion key={`accord-${index}`} expanded={expanded === `panel${index}` || expanded==='all' } onChange={handleChange( `panel${index}`)}>
                <AccordionSummary aria-controls={`panel${index}d-content`} id={`panel${index}d-header`}>
                  <Typography>{nft.collection_name} #{nft.token_id}</Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <AccordianWrapper>
                          
                        {/* fills subsection with transactions */}
                        { 
                         nft.transactions.map((transaction,innerdex)=>{
                            // displays transactions
                          if(parseInt(transaction.value)) { 
                            return <div key={`transaction-${index}-${innerdex}`}>
                            <NFTinfo >
                                <AccordianMain>
                                  <IoMdCart style={{marginLeft: '1rem'}}/>
                                </AccordianMain>
                                {/* style={{justifyContent: 'flex-start'}} */}
                                <AccordianSubWrap>
                                      <EthWrap style={{flex: '1',}}>
                                        <div style={{marginRight: '.3rem',marginLeft: '33%'}}><img  src={'./eth.svg'}/></div>
                                        <AccordianSub >{wei_to_eth(transaction.value)}</AccordianSub>
                                      </EthWrap>
                                    
                                    <div style={{flex: '1'}}>
                                           <AccordianSub style={{ marginLeft:'15%'}}>{transaction.date}</AccordianSub>
                                    </div>
                                   
                                  
                                </AccordianSubWrap>

                                <AccordianRoyaltyWrap>
                                    <EthWrap style={{marginLeft:`${transaction.royalty_amount_earned  === 0 ? '10%':' 25%'}`}} >
                                        <div style={{margin: '0 .3rem'}}><img  src={'./eth.svg'}/></div>
                                        <AccordianSub>{wei_to_eth(transaction.royalty_amount_earned)}{transaction.royalty_amount_earned  === 0  ?'(below royalty floor)' : ''}</AccordianSub>
                                      </EthWrap>

                                      {  transaction.royalty_amount_earned === 0 ?
                                      <>
                                      <QuestionWrapper
                                            onMouseEnter={e => {
                                                      changeHoverIndex(`${index}-${innerdex}`);
                                                    }}
                                                    
                                                    onMouseLeave={e => {
                                                      changeHoverIndex(``);
                                                    }}
                                          
                                          >
                                              <FaRegQuestionCircle/>
                                        </QuestionWrapper>

                                     
                                           </> : <></>}
                                </AccordianRoyaltyWrap>
                            </NFTinfo>
                           <div style={hoverIndex === `${index}-${innerdex}` ? showBubble : hideBubble}>
                                            <HelpBox text= {helpText}/>
                            </div>
                          </div>}
                          
                          // no transaction yet
                          else if( nft.transactions.filter(x=> x.value).length === 0 && innerdex < 1){
            
                            return <div key={`transaction-${index}-${innerdex}`}>
                            
                            <NFTinfo >
                               <NoTransText>No sales transactions have been made yet.</NoTransText>
                            </NFTinfo>
                          </div>
                          }


                        })}
                        

                    </AccordianWrapper>

                </AccordionDetails>
              </Accordion>)
   
          })}

          <div style={{height: '15%',width:'100%', backgroundColor: 'transparent'}}>

          </div>
            <Gradient/>
          </div>
          </AccordionBody>
     
       }

      
       </FaderContainer>
      </ActivityContainer>
  )
}


const NoTransText = styled.h5`
   color: ${props => props.theme.colors.subtitle};
   margin-left: 1rem;
   padding: .5rem 0;


`

const Box = styled.div`
    z-index: 2000000000005;
    position: absolute;
    background-color:  ${props => props.theme.colors.white};
    border-radius: ${props => props.theme.boxstyle.borderRadius};
    width: 250px;
    right: 0;
    /* width: 80%; */
    /* height: 50px; */
    /* margin: 0 10px; */
    /* margin-top: 50px; */
    /* right: 15px; */
    /* margin-top: ${({})}; */
    
    /* transition: all .05s ease-in-out; */
    /* display: none; */

    /* top: 100px; */
    /* right: 100px; */

`

const Wrapper = styled.div`
    margin:  ${props => props.theme.boxstyle.wrapperMargin};


`

const Info = styled.p`
  font-size:  .7rem;
    /* color:  ${props => props.theme.colors.subtitle}; */
 font-weight: 400;
`



 const HelpBox = (data) => {  
    const { text, extraTop } = data;
    // console.log(extraTop);
    // let marginTop = '100px';
  return (
    <Box alot={extraTop}>
        <Wrapper>
            <Info>
                {/* {extraTop} */}
                {text}
            </Info>
        </Wrapper>
    </Box>
  )
}



const EmptyConainer = styled.div`
/* background-color: red; */
height: 200px;
  display: grid;
  place-items: center;
  margin: 0 .8rem;
  width: 100%;
`

const EmptyText = styled.h1`
  text-align: center;
  text-transform: capitalize;
  color:  ${props => props.theme.colors.title};
  text-transform: uppercase;
  font-size:  ${props => props.theme.textstyle.heading};
  letter-spacing: .05rem;
  margin-bottom: 1.2rem;
  font-weight:bolder ;
  letter-spacing: 1px;


`

const Spinner = styled.div`
 
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
 
    width: 50px;
    height: 50px;
    border: 10px solid #f3f3f3; /* Light grey */
    border-top: 10px solid #383636; /* Black */
    border-radius: 50%;
    animation: spinner 1.5s linear infinite;
    opacity: .25;

`


const FaderContainer =styled.div`
   position:relative;
   height: 100%;
  
`

const Gradient =styled.div`
  position:absolute;
     z-index:200000000000;
    right:0; bottom:0; left:0;
    height:20%; /* adjust it to your needs */
    background: url(data:image/svg+xml;base64,alotofcodehere);
    background: -moz-linear-gradient(top,  rgba(85,86,89,0) 0%, rgba(85,86,89,1) 60%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(85,86,89,0)), color-stop(60%,rgba(85,86,89,1)));
    background: -webkit-linear-gradient(top,  rgba(85,86,89,0) 0%,rgba(85,86,89,1) 60%);
    background: -o-linear-gradient(top,  rgba(85,86,89,0) 0%,rgba(85,86,89,1) 60%);
    background: -ms-linear-gradient(top,  rgba(85,86,89,0) 0%,rgba(85,86,89,1) 60%);
    background: linear-gradient(to bottom,  rgba(85,86,89,0) 0%,rgba(85,86,89,1) 60%);
  /* background-color: red; */
`
